import { render, staticRenderFns } from "./LayerLegend.vue?vue&type=template&id=2014c52e&scoped=true&"
import script from "./LayerLegend.vue?vue&type=script&lang=js&"
export * from "./LayerLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2014c52e",
  null
  
)

export default component.exports